import {SpecializationFilter} from "./SpecializationFilter";

document.addEventListener('DOMContentLoaded', () => {
    
    const filterContainer = document.querySelector('.specialization');
    if (filterContainer) {
        new SpecializationFilter(filterContainer);
    }

});